/**
 * Heuristique LOCALE de force du mot de passe — purement indicative
 * (longueur + variété de caractères). Elle ne bloque jamais la soumission :
 * la validation qui fait foi reste le zod partagé + le serveur.
 */

export type StrengthLevel = 0 | 1 | 2 | 3 | 4;

export function passwordStrength(password: string): StrengthLevel {
  if (!password) return 0;
  let score = 0;
  if (password.length >= 8) score += 1;
  if (password.length >= 12) score += 1;
  const variety = [/[a-z]/, /[A-Z]/, /\d/, /[^A-Za-z0-9]/].filter((re) =>
    re.test(password),
  ).length;
  if (variety >= 2) score += 1;
  if (variety >= 3 && password.length >= 12) score += 1;
  return Math.max(1, Math.min(4, score)) as StrengthLevel;
}
